export enum HMDAReporterStatus{
    Unspecified = 0,
    Unknown = 1,
    Required = 2,
    Reporter = 3,
    NotHMDAReporter = 4
}


